var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CollapseTransition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.autoRejection),expression:"autoRejection"}],staticClass:"bg-negative text-white q-mt-sm q-pa-xs full-width text-bold",staticStyle:{"border-radius":"3px"}},[_c('center',[_c('small',[_vm._v("Recebimento de atendimentos bloqueado")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }